import React, {useEffect} from 'react'
import './appraisalTracker.css'
import { Link } from 'react-router-dom';
import { fetchSingleUserAppraisal } from '../../api/appraisalApi'
import { useSelector, useDispatch } from 'react-redux';
import {handleUserAppraisal} from '../../state/appraisalSlice'




const AppraisalTracker = () => {
    const {user} = useSelector((state)=>state.user)
    const {userAppraisal} = useSelector((state)=>state.appraisal)
    
    const dispatch = useDispatch()

    const handleFetchAppraisal = async ()=>{
        try {
            const res = await fetchSingleUserAppraisal(user?.token)
            dispatch(handleUserAppraisal(res?.data))
            console.log(res?.data)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(()=>{
        handleFetchAppraisal()
    },[])

    return (
        <section className='appraisal__tracker'>
            {/* HEADING */}
            <div className="heading">
                <div className="heading__box">
                    <div className="heading-item">
                        <h3 className="heading-title">Appraisal Tracker | </h3>
                        <i class='bx bx-home heading__title-icon'></i>
                        <Link to="/" className="heading-text">
                            Home <i class='bx bx-chevron-right heading-icon'></i>
                        </Link>
                        <span className="heading-text">
                            Appraisal Tracker <i class='bx bx-chevron-right heading-icon'></i>
                        </span>
                    </div>
                    <p className="heading-text">
                        Track Submitted Appraisal
                    </p>
                </div>
            </div>

            <div className="updateAppraisal__form">

            <div className="updateAppraisal__user-info">
                <h4 className="updateAppraisal__user-info__title">User Information</h4>
                <div className="updateAppraisal__user-item">
                    <div className="updateAppraisal__user-field">
                        <label htmlFor="name" className="updateAppraisal__user-label">
                            Name
                        </label>
                        <input type="text" className="updateAppraisal__user-input" 
                        id="name" name="name" 
                        value={user?.firstName + ' ' + user?.lastName}
                        readonly/>
                    </div>
                    <div className="updateAppraisal__user-field">
                        <label htmlFor="staffId" className="updateAppraisal__user-label">
                            Staff ID
                        </label>
                        <input type="text" className="updateAppraisal__user-input" 
                        id="name" name="staffId" value={user?.staffId}/>
                    </div>
                </div>
            </div>

            <div className="updateAppraisal__content">
                <h4 className="updateAppraisal__content-title">
                    Performance Rating/Scoring Criteria
                </h4>

                <div className="updateAppraisal__content-note">
                    <h4 className="updateAppraisal__content-note_title">
                        Key Factors
                    </h4>
                    <span className="updateAppraisal__content-note_span">
                        <span>5 = </span> Exceptional {'(Constantly exceeds position requirements – i.e. more than 90%)'}
                    </span>
                    <span className="updateAppraisal__content-note_span">
                        <span>4 =</span> Exceeded Expectations {'(Constantly meets and occasionally exceeds position requirements – i.e. 81 – 90%)'}
                    </span>
                    <span className="updateAppraisal__content-note_span">
                        <span>3 =</span> Satisfactory {'(Mostly meets the position requirements – i.e. 70 − 80% achievement)'}
                    </span>
                    <span className="updateAppraisal__content-note_span">
                        <span>2 =</span> Requires Improvement {'(Occasionally doesn’t meet minimum requirement – i.e. 50−69%)'}
                    </span>
                    <span className="updateAppraisal__content-note_span">
                        <span>1 =</span> Unsatisfactory {'(Does not meet minimum position requirement – i.e. <50% achievement)'}
                    </span>
                </div>
            </div>

            <div className="updateAppraisal__form-table">
                <h4 className="updateAppraisal__content-title">
                    Appraisal Tracker Table
                </h4>

                <div className='updateAppraisal__table-container'>
                    {userAppraisal ? (
                        <table className="updateAppraisal__table">
                            <thead className='updateAppraisal__table__head'>
                                <tr>
                                    <th>#</th>
                                    <th>Key Result Area</th>
                                    <th>Key Performance Indicator</th>
                                    <th>Employee</th>
                                    <th>HR</th>
                                    <th>MP</th>
                                </tr>
                            </thead>
                            <tbody className='updateAppraisal__table__body'>
                                {
                                    userAppraisal?.appraisal?.map((data, rowIndex)=>(
                                        <tr className='updateAppraisal__table-parent_tr' key={rowIndex}>
                                            <td className='updateAppraisal__flex-1'>{rowIndex + 1}</td>
                                            <td className='updateAppraisal__flex-2'>{data?.kra}</td>
                                            <td className='updateAppraisal__flex-3'>
                                                <tr className='updateAppraisal__table-child_tr'>
                                                    {
                                                        data?.kpi?.map((item, i)=>(
                                                            <td key={i}>{item?.name}</td>
                                                        ))
                                                    }
                                                </tr>
                                            </td>
                                            <td className='updateAppraisal__flex-4'>
                                                <tr className='updateAppraisal__table-child_tr'>
                                                    {
                                                        data?.kpi?.map((item, i)=>(
                                                            <td key={i}>
                                                                <input type="number" className="updateAppraisal__table-input" 
                                                                value={item?.score[0]?.user} readOnly/>
                                                            </td>
                                                        ))
                                                    }
                                                </tr>
                                            </td>
                                            <td className='updateAppraisal__flex-4'>
                                                <tr className='updateAppraisal__table-child_tr'>
                                                    {
                                                        data?.kpi?.map((item, i)=>(
                                                            <td key={i}>
                                                                <input type="number" 
                                                                className="updateAppraisal__table-input" 
                                                                value={item?.score[0]?.hr} readOnly/>
                                                            </td>
                                                        ))
                                                    }
                                                </tr>
                                            </td>

                                            <td className='updateAppraisal__flex-4'>
                                                <tr className='updateAppraisal__table-child_tr'>
                                                    {
                                                        data?.kpi?.map((item, colIndex)=>(
                                                            <td key={colIndex}>
                                                                <input type="number" 
                                                                className="updateAppraisal__table-input" 
                                                                value={item?.score[0]?.admin }
                                                                readOnly/>
                                                            </td>
                                                        ))
                                                    }
                                                </tr>
                                            </td>
                                        </tr>
                                    ))
                                }

                            </tbody>
                        </table>
                    ) : (
                        <div>No Data</div>
                    )}
                </div>

            </div>

        </div>
        </section>
    )
}

export default AppraisalTracker